"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EcoaAuthToken = exports.TwoFactorAuthType = void 0;
var TwoFactorAuthType;
(function (TwoFactorAuthType) {
    TwoFactorAuthType["Birth"] = "BIRTH";
    TwoFactorAuthType["Sms"] = "SMS";
})(TwoFactorAuthType = exports.TwoFactorAuthType || (exports.TwoFactorAuthType = {}));
class EcoaAuthToken {
}
exports.EcoaAuthToken = EcoaAuthToken;
//# sourceMappingURL=ecoaAccessCode.js.map